// Marquee Section Script
window.addEventListener('load', function () {
    const wrapper = document.getElementById('marquee-wrapper');
    if (wrapper) {
        const item = wrapper.innerHTML;
        wrapper.innerHTML = item.repeat(10);
        const finalContent = wrapper.innerHTML;
        wrapper.innerHTML = finalContent + finalContent;
        wrapper.style.animation = "scroll-loop 200s linear infinite";
    } else {
        console.warn("Element #marquee-wrapper not found on this page.");
    }
});
// Marquee Section Script

// Tab Section Script
function initDayTabs(section) {
  // Ensure we are looking inside the current section
  const container = section.classList.contains("trial_menu_sec") ? section : section.querySelector(".trial_menu_sec");
  if (!container) return;

  const buttons = container.querySelectorAll(".trial_menu_tab");
  const panes = container.querySelectorAll(".trial_menu_row"); // FIXED: Matches Liquid class

  buttons.forEach(button => {
    button.addEventListener("click", function(e) {
      e.preventDefault();
      const target = this.getAttribute("data-tab");

      // Remove active from all
      buttons.forEach(btn => btn.classList.remove("active"));
      panes.forEach(pane => pane.classList.remove("active"));

      // Add active to clicked
      this.classList.add("active");
      const activePane = container.querySelector("#" + target);
      if (activePane) {
        activePane.classList.add("active");
      }
    });
  });
}

// Run on normal load
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".shopify-section").forEach(section => {
    initDayTabs(section);
  });
});

// Run when section reloads in Shopify Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  initDayTabs(event.target);
});
// Tab Section Script

// Blog View All Button Script
document.addEventListener('DOMContentLoaded', function() {
  const viewAllBtn = document.getElementById('ViewAllButton');
  const blogGrid = document.querySelector('.blog-articles');
  if (viewAllBtn && blogGrid) {
    viewAllBtn.addEventListener('click', function() {
      blogGrid.classList.add('show-all');
      viewAllBtn.parentElement.style.display = 'none';
    });
  }
});
// Blog View All Button Script

// Meal Slider Script
jQuery(document).ready(function ($) {
  var $mealSlider = $('.meal_slider');

  $mealSlider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    draggable: true,
    swipe: true,
    touchMove: true,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: false,
    speed: 1000,
    touchThreshold: 10,
    infinite: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  // $mealSlider.on('wheel', function(e) {
  //   e.preventDefault();
  //   if (e.originalEvent.deltaY > 0) {
  //     $(this).slick('slickNext');
  //   } else {
  //     $(this).slick('slickPrev');
  //   }
  // });
});
// Meal Slider Script


// document.addEventListener("DOMContentLoaded", function() {
//   const textElement = document.querySelector(".wfq_cart_to_basket .wfq-btn-txt");
//   if (textElement) {
//     textElement.textContent = "Make Reservation";
//   }
// });


//  Make Reservation Script
// function changeRFQButton() {
//   var btnText = document.querySelector("#wfq_cart_to_basket .wfq-btn-txt");
//   if (btnText) {
//     btnText.textContent = "Make Reservation";
//   }
// }
// document.addEventListener("DOMContentLoaded", function () {
//   changeRFQButton();
//   setInterval(changeRFQButton, 1000);
// });
//  Make Reservation Script



  //  Make Reservation Script
  function changeRFQButton() {
    var btnText = document.querySelector("#wfq_cart_to_basket .wfq-btn-txt");
    if (btnText) {
      btnText.textContent = window.themeStrings.makeReservation;
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    changeRFQButton();
    setInterval(changeRFQButton, 1000);
  });
  //  Make Reservation Script




$(document).ready(function () {

  $('a[href^="https://st4d0w-fj.myshopify.com/#"]').on('click', function () {

    const drawer = document.querySelector('details.menu-drawer-container');
    
    if (drawer) {
      drawer.removeAttribute('open');
      
      // Trigger toggle event properly (important)
      drawer.querySelector('summary').setAttribute('aria-expanded', 'false');
    }

    // Remove overlay
    $('.menu-drawer__overlay').removeClass('menu-drawer__overlay--active');

    // Remove body scroll lock
    $('body').removeClass('overflow-hidden-mobile overflow-hidden-tablet overflow-hidden');

  });

});


// Menu Close Code 
document.addEventListener("click", function (e) {
  const link = e.target.closest('a[href*="#"]');
  if (!link) return;
  document.querySelectorAll("details[open]").forEach((detail) => {
    detail.removeAttribute("open");
  });
  document.querySelectorAll('[aria-expanded="true"]').forEach((button) => {
    button.setAttribute("aria-expanded", "false");
  });
  document.body.classList.remove("overflow-hidden", "menu-open");
  document.documentElement.classList.remove("menu-open");
});
// Menu Close Code 



document.addEventListener("DOMContentLoaded", function() {

  // Use event delegation (important for Dawn header re-render)
  document.addEventListener("click", function(e) {

    const menuLink = e.target.closest('#HeaderMenu-build-your-plan, #HeaderDrawer-build-your-plan');

    if (menuLink) {
      e.preventDefault(); // stop redirect to /search
      
      if (typeof $ !== 'undefined' && $('#planBuilderModal').length) {
        $('#planBuilderModal').modal('show'); // Bootstrap 3 trigger
      }
    }

  });

});

document.addEventListener('click', function(e) {
    if (e.target.matches('.footer_section .footer_menu li a.build-your-plan')) {
        e.preventDefault(); // optional
        document.querySelector('#HeaderMenu-build-your-plan , #HeaderDrawer-build-your-plan').click();
    }
});
 
document.addEventListener("DOMContentLoaded", function () {
  if (document.documentElement.lang === "de") {
    document.querySelectorAll(".list-menu li a,.footer_menu li a").forEach(function (link) {
      var originalUrl = link.getAttribute("href");
      if (originalUrl && originalUrl.startsWith("https://avocadomeals.com/")) {
        link.setAttribute(
          "href",
          originalUrl.replace(
            "https://avocadomeals.com/",
            "https://avocadomeals.com/de/"
          )
        );

      }

    });

  }

});